import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

interface Driver {
  id: string;
  name: string;
  phone: string;
  status: 'available' | 'busy' | 'offline';
  current_shipments: number;
  delivered_today: number;
}

interface Props {
  drivers: Driver[];
  loading: boolean;
}

const STATUS_LABEL: Record<string, string> = {
  available: 'متاح',
  busy: 'مشغول',
  offline: 'غير متاح',
};

const STATUS_CLASS: Record<string, string> = {
  available: 'bg-green-100 text-green-700 border-green-200 dark:bg-green-950/30 dark:text-green-400',
  busy: 'bg-orange-100 text-orange-700 border-orange-200 dark:bg-orange-950/30 dark:text-orange-400',
  offline: 'bg-muted text-muted-foreground',
};

export function DriversOverviewTable({ drivers, loading }: Props) {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-semibold text-foreground/80">السائقون</CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        {loading ? (
          <Skeleton className="h-[220px] w-full rounded-lg" />
        ) : drivers.length === 0 ? (
          <div className="flex items-center justify-center h-[220px] text-muted-foreground text-sm">
            لا يوجد سائقون
          </div>
        ) : (
          <div className="max-h-[220px] overflow-y-auto">
            <table className="w-full text-xs">
              <thead>
                <tr className="border-b border-border/50">
                  <th className="text-end py-1.5 font-medium text-muted-foreground">السائق</th>
                  <th className="text-center py-1.5 font-medium text-muted-foreground">الحالة</th>
                  <th className="text-center py-1.5 font-medium text-muted-foreground">رحلات نشطة</th>
                  <th className="text-center py-1.5 font-medium text-muted-foreground">رحلات اليوم</th>
                </tr>
              </thead>
              <tbody>
                {drivers.map((d) => (
                  <tr key={d.id} className="border-b border-border/30 last:border-0">
                    <td className="py-2 pe-0">
                      <span className="font-medium truncate max-w-[100px] block">{d.name || '—'}</span>
                    </td>
                    <td className="py-2 text-center">
                      <span className={cn('px-2 py-0.5 rounded-full text-[10px] font-medium border', STATUS_CLASS[d.status])}>
                        {STATUS_LABEL[d.status] ?? d.status}
                      </span>
                    </td>
                    <td className="py-2 text-center font-tabular">{d.current_shipments}</td>
                    <td className="py-2 text-center font-tabular text-green-600 dark:text-green-400">{d.delivered_today}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
